import React from 'react';
import {
  getColumnDefinition,
  CONTENT_SELECTOR_OPTIONS,
  PAGE_SELECTOR_OPTIONS,
  CUSTOM_PREFERENCE_OPTIONS,
  SORTABLE_COLUMNS,
  FILTERING_FIELDS
} from '../res/TableConfig';

import {
  Button,
  Table,
  TableContentSelector,
  TableFiltering,
  TablePageSizeSelector,
  TablePagination,
  TablePreferences,
  TableSelection,
  TableSorting,
  TableWrapLines,
  FormField,
  RadioGroup
} from '@amzn/awsui-components-react/polaris';

import axios from '../res/axios';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../res/actions';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return { }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ 
    addNotification: actionCreators.addNotification,
  },dispatch);
}

function getRandomInt(max=100) {
  return Math.floor(Math.random() * Math.floor(max));
}

class Header extends React.Component{
  render(){
    const isOnlyOneSelected = this.props.selectedChallenges.length === 1;
    return(
      <div className='awsui-util-action-stripe'>
        <div className='awsui-util-action-stripe-title'>
          <h2>Challenges&nbsp;
            {this.props.counter ? <span className='custom-action-stripe-counter'>{this.props.counter}</span> : ''}
          </h2>
        </div>
        <div className='awsui-util-action-stripe-group'>
          {/* <Button text='View details' disabled={!isOnlyOneSelected}/>
          <Button text='Edit' disabled={!isOnlyOneSelected}/> */}
          <Button text='Reset Progress' disabled={this.props.selectedChallenges.length === 0}/>
          <Button variant='primary' text='View Details' disabled={!isOnlyOneSelected}/>
        </div>
      </div>
    );
  }
}

class ChallengesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedChallenges: [],
      challenges: [],
      pagesCount: 1,
      currentPageIndex: 1,
      filteringText: '',
      sortingDescending: false,
      pageSize: 10,
      loading: true,
      filteringDisabled: false
    };
    this.loadItems = this.loadItems.bind(this);
  }

  componentDidMount() {
    this.loadItems();
  }
  componentDidUpdate(prevProps) {
      if(this.props.domainId !== prevProps.domainId) {
          this.loadItems();
      }
  }

  loadItems() {
    // window.fetchItems(this.state, ({ items, pagesCount, currentPageIndex }) => this.setState({
    //   distributions: items,
    //   pagesCount,
    //   currentPageIndex,
    //   loading: false,
    //   filteringDisabled: false
    // }));
    this.setState({
            loading: true
    });
    let headers = {
        'x-csrf-token': localStorage.getItem('BOTSE_SESSION_TOKEN'),
        'Action': 'Challenge:ListChallenges'
    };
    let params = {
        domainId: this.props.domainId
    };
    axios.get("action", {headers: headers, params: params})
    .then(res => {
        console.log(res);
        res.data = JSON.parse(res.data);
        console.log(res.data.data);
        const errorCode = res.data.error.code ? res.data.error.code : null;
        if (errorCode === "403") {
          this.setState({
            loading: false,
            challenges: []
          });
          var notification = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch challenges!",
            content: "You do not have permissions to view challenges under this domain",
          };
          this.props.addNotification(notification);
        }
        else if (errorCode === null){
          const challenges = res.data.data.challenges;
          this.setState({
            loading: false,
            challenges: challenges
          });
        }
        else {
          this.setState({
            loading: false,
            challenges: []
          });
          var notice = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch challenges!",
            content: "There was some unexpected error to load the challenges. Please check your internet connection and if the issue persists, please contact the bottlenose team",
          };
          this.props.addNotification(notice);
        }
    })
    .catch((err) => {
      console.log(err);
      this.setState({
        loading: false,
        challenges: []
      });
      var notification = {
        id : getRandomInt(),
        type: "error",
        dismissible: true,
        autoHide: true,
        header: "Failed to fetch challenges!",
        content: "Please check your internet connectivity and reload the page.",
      };
      this.props.addNotification(notification);
    });
  }

  onPaginationChange(evt) {
    this.setState({
      pageSize: evt.detail.pageSize,
      currentPageIndex: evt.detail.currentPageIndex
    });
  }

  onSortingChange(evt) {
    this.setState({
      sortingColumn: evt.detail.sortingColumn,
      sortingDescending: evt.detail.sortingDescending
    });
  }

  onFilteringChange(evt) {
    this.setState({
      filteringText: evt.detail.filteringText
    });
  }

  onSelectionChange(evt) {
    this.setState({
      selectedChallenges: evt.detail.selectedItems
    });
  }

  headerCounter(selectedChallenges) {
    return selectedChallenges.length
      ? `(${selectedChallenges.length} selected)`
      : '';
  }

  clearFilter() {
    this.setState({
      filteringText: ''
    });
  }

  render() {
    return (
      <Table
        columnDefinitions={getColumnDefinition(this.props.location.pathname)}
        items={this.state.challenges}
        header={(
          <Header
            selectedChallenges={this.state.selectedChallenges}
            counter={this.headerCounter(this.state.selectedChallenges)}
          />
        )}
        loading={this.state.loading}
        empty={
          <div className="awsui-util-t-c">
            <div className="awsui-util-pt-xs awsui-util-mb-xs">
              <b>No challenges found</b>
            </div>
          </div>
        }
        noMatch={
          <div className="awsui-util-t-c">
            <div className="awsui-util-pt-xs awsui-util-mb-xs">
              <b>No challenges found</b>
            </div>
            <p className="awsui-util-mb-s">No results match your query</p>
            <div className="awsui-util-mb-l">
              <Button onClick={this.clearFilter.bind(this)} text="Clear filter"/>
            </div>
          </div>
        }
      >
        <TableFiltering
          filteringPlaceholder='Search challenges'
          filteringFields={FILTERING_FIELDS}
          onFilteringChange={this.onFilteringChange.bind(this)}
          disabled={this.state.filteringDisabled}
          filteringText={this.state.filteringText}
        />
        <TablePagination
          currentPageIndex={this.state.currentPageIndex}
          pageSize={this.state.pageSize}
          onPaginationChange={this.onPaginationChange.bind(this)}
          disabled={this.state.loading}
        />
        <TableSorting
          sortingColumn={this.state.sortingColumn}
          sortableColumns={SORTABLE_COLUMNS}
          disabled={this.state.loading}
          onSortingChange={this.onSortingChange.bind(this)}
        />
        <TableSelection
          selectedItems={this.state.selectedChallenges}
          onSelectionChange={this.onSelectionChange.bind(this)}
        />
        <TablePreferences
          title='Preferences'
          confirmLabel='Confirm'
          cancelLabel='Cancel'
          disabled={this.state.loading}
        >
          <TablePageSizeSelector
            title='Page size'
            options={PAGE_SELECTOR_OPTIONS}
            value={this.state.pageSize}
          />
          <TableWrapLines
            label='Wrap lines'
            description='Check to see all the text and wrap the lines'
            value={false}
          />
          <FormField
            stretch={true}
            className='awsui-table-custom-preference'
            label='View as'
          >
            <RadioGroup
              value='table'
              items={CUSTOM_PREFERENCE_OPTIONS}
            />
          </FormField>
          <TableContentSelector
            title='Select visible columns'
            options={CONTENT_SELECTOR_OPTIONS}
          />
        </TablePreferences>
      </Table>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengesTable);



// WEBPACK FOOTER //
// ./src/app/components/ChallengesTable.jsx



// WEBPACK FOOTER //
// ./src/app/components/ChallengesTable.jsx